import React from 'react';
import { Link } from 'react-router-dom';
import { FiCheckCircle, FiArrowRight, FiCalendar } from 'react-icons/fi';
import SeoHead from '../components/SeoHead';
import { services } from '../data/services';
import './ServicesPage.css';

const comparison = [
  { feature: 'Audit', price: '₹2,360', timeline: '5 days', best: 'Existing websites' },
  { feature: 'Website', price: '₹14,160', timeline: '10 days', best: 'New / redesign projects', highlight: true },
  { feature: 'SEO Blogs', price: '₹5,900/mo', timeline: 'Monthly', best: 'Ongoing SEO growth' },
];

const ServicesPage = () => {
  return (
    <>
      <SeoHead
        title="Services — Web, Mobile, IoT &amp; Digital Marketing"
        description="Web, mobile, desktop, IoT, AI, digital marketing and SEO services from THINKINGWORLD — one studio for design, build and growth."
        path="/services"
      />

      <header className="page-header">
        <div className="container">
          <span className="section-eyebrow">Services</span>
          <h1>Design, build, and grow — under one roof.</h1>
          <p>
            Pick a single service or bundle the whole stack. Every engagement
            comes with a written scope, a fixed timeline and a single point
            of contact.
          </p>
        </div>
      </header>

      <section className="section">
        <div className="container">
          <div className="services-page-grid">
            {services.map((s) => {
              const Icon = s.icon;
              return (
                <article
                  key={s.slug}
                  id={s.slug}
                  className="service-detail-card"
                  style={{ '--svc-accent': s.accent }}
                >
                  <div className="service-detail-head">
                    <div className="service-icon"><Icon /></div>
                    <div>
                      <h2 dangerouslySetInnerHTML={{ __html: s.title }} />
                      <p className="service-detail-short">{s.short}</p>
                    </div>
                  </div>

                  <p className="service-detail-desc">{s.description}</p>

                  <ul className="service-detail-bullets">
                    {s.bullets.map((b) => (
                      <li key={b}>
                        <FiCheckCircle /> <span>{b}</span>
                      </li>
                    ))}
                  </ul>

                  <div className="service-detail-foot">
                    <ul className="service-tags">
                      {s.tags.map((t) => <li key={t}>{t}</li>)}
                    </ul>
                    <Link to="/schedule" className="btn btn-link">
                      Get a quote <FiArrowRight />
                    </Link>
                  </div>
                </article>
              );
            })}
          </div>
        </div>
      </section>

      <section className="section section--alt">
        <div className="container">
          <div className="section-header">
            <span className="section-eyebrow">At a glance</span>
            <h2 className="section-title section-title--center">Quick comparison</h2>
            <p className="section-lead section-lead--center">
              The three engagements clients ask about most. Custom scopes are
              quoted after a discovery call.
            </p>
          </div>

          <div className="comparison-wrap">
            <table className="comparison">
              <thead>
                <tr>
                  <th>Feature</th>
                  {comparison.map((c) => (
                    <th key={c.feature} className={c.highlight ? 'comparison-highlight' : ''}>
                      {c.feature}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Price</td>
                  {comparison.map((c) => (
                    <td key={c.feature} className={c.highlight ? 'comparison-highlight-cell' : ''}>
                      {c.price}
                    </td>
                  ))}
                </tr>
                <tr>
                  <td>Timeline</td>
                  {comparison.map((c) => (
                    <td key={c.feature} className={c.highlight ? 'comparison-highlight-cell' : ''}>
                      {c.timeline}
                    </td>
                  ))}
                </tr>
                <tr>
                  <td>Best for</td>
                  {comparison.map((c) => (
                    <td key={c.feature} className={c.highlight ? 'comparison-highlight-cell' : ''}>
                      {c.best}
                    </td>
                  ))}
                </tr>
              </tbody>
            </table>
          </div>

          <div className="comparison-cta">
            <Link to="/schedule" className="btn btn-accent">
              <FiCalendar /> Schedule a free consult
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default ServicesPage;
